import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  replyRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-end',
  },
}))

export default useStyles
